// 메뉴 클릭

import { useTranslation } from "react-i18next";
import useAlertStore from "store/alert";
import useLodStore from "store/lod";
import useMdiStore from "store/menus";

/**
 * 메뉴 클릭
 */
type menuItemProps = {
  item: any;
};

export const useMenuClick = () => {
  const { t } = useTranslation();
  const lod = useLodStore((state) => state.lod);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { setMenuList, menuList, tabs, setActivePage } = useMdiStore();

  const lodNo = lod?.lodNo;

  const onMenuClick = ({ item }: menuItemProps) => {
    // 숙소 선택 여부 체크
    if (!lodNo) {
      onSetAlert({
        isOpen: true,
        inner: t("alt_menu_click"),
      });
      // e.preventDefault();
      return;
    }

    // 탭이 최대 8개까지
    // if (tabs.length >= maxTabs) {
    //   return handleAlert({
    //     isOpen: true,
    //     inner: "탭을 최대" + maxTabs + "까지 가능합니다.",
    //   });
    // }

    //  클릭한 메뉴 추가
    setActivePage(item.id);

    // 권한 체크 필요 여부
    // opendPages 에 포함되면 이미 권한 체크 완료 | 권한 체크 필요
    const isPermission = tabs.some((_page) => {
      return _page.id === item.id;
    });

    if (!isPermission) {
      // 권한 체크 api
      const isAble = true; // 접속 가능 여부 확인
      const curd = "R";

      if (!isAble) {
        return onSetAlert({
          isOpen: true,
          inner: "접속 권한이 없습니다.",
          onSetConfirm: () => {
            //
          },
        });
      }

      // 권한 확인후 해당 권한 업데이트
      const menus = menuList.map((_route) => {
        const menu = _route.menu.map((_menu) => {
          return _menu.id === item.id
            ? {
                ..._menu,
                permission: curd,
              }
            : _menu;
        });

        return {
          ..._route,
          menu,
        };
      });

      setMenuList(menus);
    }
  };

  return {
    menuList: menuList,
    onMenuClick,
  };
};
